import { connect } from 'react-redux';
import TeamView from './team_view';
import { getContent, getContentBySlug, getContentByProp, getChapterFilter } from '../../../reducer';
// import { SomeActions } from '../../actions';

// Pull specific state out of the Redux store that you need to render
// this component's view using this function.
// Do not retrieve any state that is not used directly by the view.
// Do not associate full objects when all you need are Ids.
// Let child components pull their own properties.
//
// mapStateToProps(dispatch, { prop })
const mapStateToProps = (state) => ({
  // prop assignments
  leaders: getContent(state, 'leaders'),
  founder: getContentBySlug(state, 'leaders', 'vanessa-dawson'),
  chapterDirectors: getContentByProp(state, 'leaders', 'role', 'Chapter Directors'),
  advisoryCommittee: getContentByProp(state, 'leaders', 'role', 'Advisory Committee'),
  ventureCommittee: getContentByProp(state, 'leaders', 'role', 'Venture Committee'),
  boardAdvisors: getContentByProp(state, 'leaders', 'role', 'Board Advisor'),
  page: getContentBySlug(state, 'pages', 'team'),
  filter: getChapterFilter(state),
});

// Wire up specific actions using this function. If you directly map an
// action creator, it will be automatically wrapped with `dispatch()`,
// so do not define new functions here unless you need to override or
// explicitly specify a parameter of an action creator based on the
// nature of the component or its props.
//
// mapDispatchToProps(dispatch, { prop })
const mapDispatchToProps = () => ({
  // action creator assignments
});

const TeamContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(TeamView);

export default TeamContainer;
